<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <h2 class="blind">
        <span v-if="openMarketInfo.shndHphnYn === 'Y'">중고폰&nbsp;</span>
        <span v-if="openMarketInfo.rsvSaleYn === 'Y'">예약판매&nbsp;</span>
        가입신청 완료
      </h2>
      <div class="message-box" tabindex="0">
        <p class="message-text">
          <span v-if="openMarketInfo.shndHphnYn === 'Y'">중고폰&nbsp;</span>
          <span v-if="openMarketInfo.rsvSaleYn === 'Y'">예약판매&nbsp;</span>
          가입신청이 완료되었습니다.<br />
          <strong class="primary-text">LG U<sup>+</sup></strong
          >를 선택해주셔서 감사합니다.
        </p>
        <div class="section-separator" />

        <div class="group-horizontal">
          <p class="message-text">
            <span class="message-text-small">신청번호</span>
            <span class="space"></span>
            <span class="message-text-temp">{{ registration.onlnAppfNo }}</span>
          </p>
        </div>
        <div class="section-separator" />
        <p class="data-text">
          <span class="dynamic-data-temp">{{ registration.dealNm }}</span>
          을(를) 통해
          <span class="space"></span>
          <span>{{ registration.aplcNmMask }}</span>
          님의 LG유플러스 서비스 가입신청이 접수되었습니다.
        </p>
      </div>
      <div class="section">
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              신청내역은 고객님이 가입신청 시 기재하신 이메일로 발송되었으며
              추후 수정을 원하시면 이메일을 통해 작성하신 계약서에 접속하여
              처리가 가능합니다.
            </li>
            <li class="notice-text">
              <em class="primary-text"
                >타인납부 결재시 납부자 동의를 완료하셔야 가입 신청이
                완료됩니다.</em
              >
            </li>
            <li class="notice-text">
              가입신청과 관련한 문의는 신청하신 대리점으로 연락 주시기 바랍니다.
            </li>
          </ul>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h2>
            <span v-if="openMarketInfo.shndHphnYn === 'Y'">중고폰&nbsp;</span>
            <span v-if="openMarketInfo.rsvSaleYn === 'Y'">예약판매&nbsp;</span>
            가입신청내역 최종확인
          </h2>
        </div>
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              아래의 가입하신 정보는 회원님들의 동의 없이 공개되지 않으며,
              개인정보보호 정책에 의해 보호 받습니다.<br />
              LG유플러스 회원님의 개인정보보호를 위해 최선을 다할것을
              약속드립니다.
            </li>
            <!-- <li class='notice-text'>아래 내용을 확인하시고 화면 하단 다음단계(본인인증)로 넘어가시기 바랍니다.
            </li> -->
          </ul>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h3>구매자정보 / 가입자 정보</h3>
          <a
            v-if="
              (registration.rqstPgrsStusCd === '20' &&
                registration.cnslPgrsStusCd === '00') &&
                openMarketInfo.rsvSaleYn !== 'Y'
            "
            class="link-button secondary-button"
            id="btnMod1"
            href="#"
            target="_self"
            @click="backToPreviousStep('1')"
            title="입력사항 수정페이지로 화면전환"
            >수정</a
          >
        </div>
      </div>

      <!-- 구매자정보뷰 -->
      <div v-if="openMarketInfo.entrRqstFomNo">
        <BasicInformationSectionView :openMarketInfoProps="openMarketInfo" />
      </div>
      <!-- 가입자정보뷰 -->
      <div v-if="registration.appfNo && entrRsvTruthInfo.onetMblAppfNo">
        <CustomerSectionView
          :entrRsvTruthInfoProps="entrRsvTruthInfo"
          :registrationProps="registration"
        />
      </div>
      <!-- 법정대리인정보뷰 -->
      <div v-if="registration.custKdCd === 'A'">
        <div v-if="lawcAgntEntrRsvTruthInfo.onetMblAppfNo">
          <GuardianSectionView
            :lawcAgntEntrRsvTruthInfoProps="lawcAgntEntrRsvTruthInfo"
            :registrationProps="registration"
          />
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h3>가입내역 / 신청내역 / 선택사항</h3>
          <a
            v-if="
              (registration.rqstPgrsStusCd === '20' &&
                registration.cnslPgrsStusCd === '00') &&
                openMarketInfo.rsvSaleYn !== 'Y'
            "
            class="link-button secondary-button"
            id="btnMod2"
            href="#"
            target="_self"
            @click="backToPreviousStep('2')"
            title="입력사항 수정페이지로 화면전환"
            >수정</a
          >
        </div>
      </div>

      <!-- 번호이동고객-->
      <div v-if="openMarketInfo.registrationTypeCode === 'move'">
        <TransferCompanySectionView :registrationProps="registration" />
      </div>

      <!-- 가입내역뷰 -->
      <div v-if="registration.appfNo && openMarketInfo.entrRqstFomNo">
        <DeviceSectionView
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
        />
      </div>

      <!-- 의무약정뷰 -->
      <div
        v-if="
          registration.dutyAgmtAgrYn === 'Y' &&
            openMarketInfo.entrRqstFomNo
        "
      >
        <RouterAgreedSectionView
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
        />
      </div>

      <!-- 부가서비스뷰 -->
      <div v-if="registration.appfNo">
        <AdditionalServiceSectionView :registrationProps="registration" />
      </div>

      <!-- 보안선택사항뷰 -->
      <!-- <div v-if="registration.appfNo">
        <SecureOptionSectionView :registrationProps="registration" />
      </div> -->

      <div v-if="!(this.registration.entrRqstFomNo==='2487500' || this.registration.entrRqstFomNo==='2487501' || this.registration.entrRqstFomNo==='2487502' || this.registration.entrRqstFomNo==='2487503')">    
        <!-- 할부내역뷰 -->
        <div v-if="registration.appfNo && openMarketInfo.isttYn === 'Y' && openMarketInfo.shndHphnYn !== 'Y'">
          <InstallmentSectionView
            :openMarketInfoProps="openMarketInfo"
            :registrationProps="registration"
          />
        </div>
      </div>
      <div v-if="this.registration.entrRqstFomNo==='2487500' || this.registration.entrRqstFomNo==='2487501' || this.registration.entrRqstFomNo==='2487502' || this.registration.entrRqstFomNo==='2487503'">    
        <div class="sub-section">
          <ul class="notice-text-list">
            <li class="notice-text">
              월 납부 예상금액은 삼성닷컴에서 확인 바랍니다.
            </li>
          </ul>
        </div>          
      </div>            

      <!-- LTE -->
      <div v-if="openMarketInfo.rotrRqstCd === 'N' && formM2MYn === 'Y'">
        <LtePlusSectionView :openMarketInfoProps="openMarketInfo" />
      </div>

      <!-- 배송지 -->
      <!-- <div v-if="registration.appfNo">
        <ShipToAddrSectionView :registrationProps="registration" />
      </div> -->

      <!-- 납부정보 -->
      <div
        v-if="
          openMarketInfo.registrationTypeCode === 'move' ||
            openMarketInfo.registrationTypeCode === 'new'
        "
      >
        <div v-if="registration.appfNo">
          <PayInformationSectionView :registrationProps="registration" />
        </div>
      </div>

      <div class="step-bottom-area input-wrap">
        <button
          class="primary-button mw100 pc-float-right"
          @click="endRegistration"
        >
          확인
        </button>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import BasicInformationSectionView from '../step3/BasicInformationSectionView'
import CustomerSectionView from '../step3/CustomerSectionView'
import GuardianSectionView from '../step3/GuardianSectionView'
import TransferCompanySectionView from '../step3/TransferCompanySectionView'
import DeviceSectionView from '../step3/DeviceSectionView'
import RouterAgreedSectionView from '../step3/RouterAgreedSectionView'
import AdditionalServiceSectionView from '../step3/AdditionalServiceSectionView'
//import SecureOptionSectionView from '../step3/SecureOptionSectionView'
import InstallmentSectionView from '../step3/InstallmentSectionView'
import LtePlusSectionView from '../step3/LtePlusSectionView'
//import ShipToAddrSectionView from '../step3/ShipToAddrSectionView'
import PayInformationSectionView from './PayInformationSectionView'
import { watchRefreshKeyPress } from '@/system/common'
import { getRegistration } from '@/api/captureService'
import { getOpenMarketInfo } from '@/api/openmarket'
import { router } from '@/router/router'

export default {
  name: 'RegistrationStep4_samsung',

  components: {
    BasicInformationSectionView,
    CustomerSectionView,
    GuardianSectionView,
    TransferCompanySectionView,
    DeviceSectionView,
    RouterAgreedSectionView,
    AdditionalServiceSectionView,
    //SecureOptionSectionView,
    InstallmentSectionView,
    LtePlusSectionView,
    //ShipToAddrSectionView,
    PayInformationSectionView
  },

  props: {},

  data() {
    return {
      openMarketInfo: {
        dealNm: '',
        agentId: '',
        agentName: '',
        agentAddress: '',
        agentTelNo: '',
        sellerName: '',
        sellerAddress: '',
        sellerTelNo: '',
        sellerRegistrationNo: '',
        sbgnPosCd: '',
        sbgnPosNm: '',
        openMarketCode: '', //오픈마켓번호
        openMarketName: '',
        msBsType: '', //기업부문 BS
        entrRqstFomNo: '', //양식ID
        dealCd: '', //대리점코드
        opmkEntrKdCd: '', //가입유형코드
        isttYn: '', //할부여부
        isttAmt: '', //할부금액
        registrationTypeCode: '', //가입유형
        registrationTypeName: '', //가입유형명
        rotrRqstCd: '',
        shndHphnYn: '', //중고여부
        rcmdSaleKcCd: '', //추천판매 agmtTermMmct discGb
        mblSvcDivsCd: '', //G106M2MLZP0002200모바일서비스구분코드
        dataPpMndtYn: '', //데이터요금제 필수여부
        dlrGroup: '',
        resCode: '',
        resMsg: '',
        onetDealOrgDivsCd: '',
        appfTitNm: '',
        appfDutyAgmtAmt: '',
        crgrSaleYn: '',
        rqstCustDelKdCd: '',
        rqstOrdrNoTitNm: '',
        rqstTmpDutyAgmtAmt: '',
        onetRcmdSaleCd: '',
        appfUseStrtDttm: '',
        appfUseEndDttm: '',
        ppfUseYn: '',
        rqstBdlProdCd: '',
        rsvSaleNm: '',
        dcntKdNm: '',
        chocAgmtMmct: '',
        addSuptAmtUseYn: '',
        rotrRqstYn: '',
        svcDivsCd: '',
        rsvSaleYn: '',
        miltaryAgentYn: '',
        emalAddr: '',
        faxNo: '',
        chocAgmtDcntUseYn: ''   // 할인유형명
        // [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
        ,lrpsDiscOpenYn : 'N'   // 단통법폐지 프로젝트 오픈여부
        ,presaleTrmMdlCdYn:'N'    // 단통법폐지 프로젝트 오픈 전 사전예약판매단말여부
        ,presaleTrmMdlCdTxt : '' // 단통법폐지 프로젝트 오픈 전 사전예약판매단말ID(여러건인경우,구분자)
        ,dmbrYn:'N'               //직영점여부
        // [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
      },
      registration: {
        dcntKdNm: '', // 할인유형명
        pymnBday: '', // 납부자생년월일
        appfNo: '', //신청서번호
        crypAppfNo: '', //암호화 신청서번호
        rqstPgrsStusNm: '', //신청진행상태명
        onetKdCd: '', //가입유형코드
        onetKdNm: '', //가입유형명
        ppCd: '', //요금제코드
        sppsProdCdCntn: '', //부가서비스상품코드내용
        dataPpCd: '', //데이터요금제코드
        custKdCd: '', //고객유형코드
        aplcNm: '', //신청자명
        aplcDerno: '', //신청자주민등록번호--------------->최초
        aplcDernoMask: '', //신청자주민등록번호--------------->마스킹
        aplcTlno: '', //신청자전화번호
        aplcEmalAddr: '', //신청자이메일주소
        bltxRcepMthdCd: '', //청구서수령방법코드
        billDivsCd: '', //청구구분코드
        crplZpcd: '', //청구지우편번호
        crplAddr: '', //청구지주소
        crplDadr: '', //청구지상세주소
        pymnDivsCd: '', //납부자구분코드 TODO 본인:1 / 타인:2
        pymnNm: '', //납부자명 TODO 청소년이면 대리인
        pymnDerno: '', //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
        pymnEmalAddr: '', //납부자이메일주소 TODO 청소년이면 대리인
        paymMthdDivsCd: '', //납부방법구분코드
        bankNm: '', //은행명
        CdcoNm: '', //카드사명
        onetBankCd: '', //온라인가입은행코드
        onetCdcoCd: '', //온라인가입카드사코드
        acctCardNo: '', //계좌카드번호--------------->화면보기
        acctCardNoMask: '', //계좌카드번호마스킹
        ccrdValdTermEndYymm: '', //신용카드유효기간종료년월
        wdrwAgrYn: '', //출금동의여부
        mnpSoacTrgtCd: '', //번호이동정산대상코드
        mnpSoacNo: '', //번호이동정산번호
        noRnftEnprCd: '', //번호이동전사업자코드
        trmSrno: '', //단말시리얼번호
        dvicMdlCd: '', //단말기모델코드
        dvicMdlNm: '', //단말기모델명
        dvicColrCd: '', //단말기색상코드
        hphnColrNm: '', //휴대폰색상명
        chgHopTlno: '', //변경희망전화번호
        crgrBuyYn: 'N', //충전기구매여부
        ppNm: '', //요금제명
        dataPpNm: '', //데이터요금제명
        sppsProdNmCntn: '', //부가서비스상품명내용
        adltCntsIsolRqstYn: '', //성인컨텐츠차단신청여부
        agntEntrRstnYn: '', //대리인가입제한여부
        lawcAgntNm: '', //법정대리인명
        decLawcAgntCrypRrno: '', //------->입력
        lawcAgntCrypRrnoMask: '', //법정대리인암호화주민등록번호마스킹
        lawcAgntTlno: '', //법정대리인전화번호
        lawcAgntZpcd: '', //법정대리인우편번호
        lawcAgntAddr: '', //법정대리인주소
        lawcAgntDadr: '', //법정대리인상세주소
        isttTermMmct: '24', //할부기간개월수 halbuMonth
        tinsAmt: '0', //총할부금액 halbuPrice
        adseRqstDivsCd: '', //선결제신청구분코드
        lssInsrDivsNm: '', //분실보험구분명
        dcntDivsCd: '', //할인구분코드
        dcntTermMmct: '', //할인기간개월수 =agreedMonthM2M / discMonth
        dcntKdCd: '', //할인유형코드
        agmtTermMmct: '0', //약정기간개월수
        onsaAplyPlnNm: '', //온라인가입지원적용플랜명
        iphnUseAgrYn: '', //아이폰사용동의여부
        nwIsolYn: '', //네트워크차단여부
        entrAppfDvrMthdCd: '', //가입신청서교부방법코드
        entrAppfDvrMthdNm: '', //가입신청서교부방법명
        dlvRcipNm: '', //배송수령자명
        dlplZpcd: '', //배송지우편번호
        dlplBadr: '', //배송지기본주소
        dlplDadr: '', //배송지상세주소
        dlplTlno: '', //배송지전화번호
        dlvCtplNm: '', //배송연락처명
        custInfoGthrAgrYn: '', //고객정보수집동의여부
        pnifPuseTrstAgrYn: '', //개인정보활용위탁동의여부
        locFndnInfoOfrSvcAgrYn: '', //위치기반정보제공서비스동의여부
        autnMthdDivsCd: '', //인증방법구분코드
        prmsLinePcnt: '', //허용회선개수
        addReqMttrCntn: '', //추가요청사항내용
        dutyAgmtSuptAmt: '0', //의무약정지원금액 =dutyAgmtSuptAmt
        hphnInitStlmAmt: '', //휴대폰초기결제금액
        lssInsrCnslAgrYn: '', //분실보험상담동의여부
        dutyAgmtAgrYn: 'N', //의무약정동의여부 agreedAgreeYn
        rqstSppsCdCntn: '', //신청부가서비스코드내용
        dealAgmtAmt: '0', //대리점약정금액
        custBday: '', //고객생년월일
        lawcAgntAgrYn: '', //법정대리인동의여부
        smatAppUseYn: '', //스마트APP사용여부
        bukeAppUseYn: '', //사업지키미APP사용여부f
        rotrRqstYn: '', //라우터신청여부 formRoutrYn
        rotrAgmtMmct: '0', //라우터약정개월수
        rotrAgmtAmt: '0', //라우터약정금액
        browDivsCd: '', //브라우저구분코드
        rqstSppsNmCntn: '', //신청부가서비스명내용
        entrRqstFomNo: '', //가입신청양식번호
        opmkNo: '', //오픈마켓번호
        onlnAppfNo: '', //온라인신청서번호
        sbgnPosCd: '', //개통POS코드
        sbgnDealCd: '', //개통대리점코드
        dealNm: '', //대리점명
        opmkNm: '', //오픈마켓명
        svcDivsCd: '', //서비스구분코드
        shpnEntrRqstYn: '', //중고폰가입신청여부
        aplcNmMask: '', //마스킹 신청자명
        aplcTlnoMask: '', //마스킹 신청자전화번호
        aplcEmalAddrMask: '', //마스킹 신청자이메일주소
        lawcAgntNmMask: '', //마스킹 법정대리인명
        lawcAgntTlnoMask: '', //마스킹 법정대리인전화번호
        dlvRcipNmMask: '', //마스킹 배송수령자
        dlplTlnoMask: '', //마스킹 배송지전화번호
        dlplTlno2Mask: '', //마스킹 배송지전화번호 2
      },
      entrRsvTruthInfo: {
        onetMblAppfNo: '',
        onetIdcdDivsCd: '', //G116
        onetIndvDivsCd: '', //G117
        onetDivsCd: '', //G129
        agrYn: '',
        lawcAgntAgrYn: '',
        custNm: '',
        isuDt: '',
        drvLcnsNo: '', //초기입력
        drvLcnsNoMask: '', //화면
        crypDrvLcnsNo: '', //DB
        drvLcnsIsuAreaCd: '',
        bday: '',
        lawcAgntNm: '',
        coBrno: '',
        conmNm: '',
        monmCsntNo: ''
      },
      lawcAgntEntrRsvTruthInfo: {
        onetMblAppfNo: '',
        onetIdcdDivsCd: '', //G116
        onetIndvDivsCd: '', //G117
        onetDivsCd: '', //G129
        agrYn: '',
        lawcAgntAgrYn: '',
        custNm: '',
        isuDt: '',
        drvLcnsNo: '', //초기입력
        drvLcnsNoMask: '', //화면
        crypDrvLcnsNo: '', //DB
        drvLcnsIsuAreaCd: '',
        bday: '',
        lawcAgntNm: '',
        coBrno: '',
        conmNm: '',
        monmCsntNo: ''
      },

      formM2MYn: ''
    }
  },

  computed: {},

  created() {
    watchRefreshKeyPress()
  },

  beforeMount() {
    
  },

  mounted() {
    //alert('step4 mounted')
    this.initPage()
    this.$store.state.processIndicator.step1 = false
    this.$store.state.processIndicator.step2 = false
    this.$store.state.processIndicator.step3 = false
    this.$store.state.processIndicator.step4 = true
  },

  methods: {
    /** 
     * Function    : initPage
     * Description : Step4 초기값 세팅
     **/
    initPage() {
      let applicationNumber = this.$store.state.applicationNumber
      this.hasApplicationNumber = false
      if (applicationNumber !== '') {
        this.hasApplicationNumber = true
        getRegistration(applicationNumber, "L").then(res => {
          this.registration = res.data.opmktRegistrationCapture
          this.getOpenMarketInfo(
            this.registration.sbgnDealCd,
            this.registration.entrRqstFomNo,
            this.registration.opmkNo
          ) // openmarketInfo 저장

          if (res.data.entrRsvTruthInfo !== null) {
            this.entrRsvTruthInfo = res.data.entrRsvTruthInfo
          }

          if (res.data.lawcAgntEntrRsvTruthInfo !== null) {
            this.lawcAgntEntrRsvTruthInfo = res.data.lawcAgntEntrRsvTruthInfo
          }
        })
      }
    },

    /** 
     * Function    : getOpenMarketInfo
     * Description : 오픈마켓 정보
     **/
    getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo) {
      if(!sbgnDealCd|| !entrRqstFomNo || !opmkNo) {
        this.openAlert(
          '온라인 가입신청 안내',
          '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
        )
        return
      }
      getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo).then(res => {
        this.openMarketInfo = res.data
        if (this.openMarketInfo.mblSvcDivsCd === 'LZP0002200') {
          this.formM2MYn = 'Y' //ASIS agreedYn : 'none'
        } else {
          this.formM2MYn = 'N' //ASIS agreedYn : ''
        }
        if (!this.openMarketInfo.entrRqstFomNo) {
          router.replace({
            name: 'Error',
            props: true,
            params: {
              message:
                '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
              type: 'access'
            }
          })
        }

        //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
        this.$store.state.openMarketInfo.lrpsDiscOpenYn     = this.openMarketInfo.lrpsDiscOpenYn;
        this.$store.state.openMarketInfo.presaleTrmMdlCdTxt = this.openMarketInfo.presaleTrmMdlCdTxt;
        this.$store.state.openMarketInfo.dmbrYn             = this.openMarketInfo.dmbrYn;               // 직영점여부
        this.$store.state.openMarketInfo.dbnwSufuAcacgCd    = this.openMarketInfo.dbnwSufuAcacgCd;      // 획득비분석채널그룹코드
        //[단통법폐지Prj] End 단통법 폐지관련 추가. 2025.06.04 miyoung34
      })
    },

    /** 
     * Function    : backToPreviousStep
     * Description : 수정 버튼 클릭 이벤트
     **/
    backToPreviousStep(index) {
      if (index === '1') {
        this.$store.state.step2Accordion.isStep1 = true
        this.$store.state.step2Accordion.isStep2 = false
      } else if (index === '2') {
        this.$store.state.step2Accordion.isStep1 = false
        this.$store.state.step2Accordion.isStep2 = true
      }
      this.$router.replace({
        name: 'RegistrationStep2_samsung'
      })
    },

    /** 
     * Function    : endRegistration
     * Description : 최종 확인 버튼 클릭 이벤트
     **/
    endRegistration() {
      this.$modal.show('dialog', {
        title: '<h1>온라인 가입신청 안내</h1>',
        text:
          // '보고 계신 창을 닫으시겠습니까?<br>https://onsalemobile.uplus.co.kr 을 통해<br>가입진행상황을 조회 하실 수 있습니다.',
          '고객님께서 입력하신 이메일로 세부 내용을 발송드렸습니다.',
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              self.close()
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    }
  }
}
</script>
<style scoped></style>
